import { Box, useTheme } from "@mui/material";
import { Button } from "components/button";
import { useAtomValue, useSetAtom } from "jotai";
import { memo, useCallback } from "react";
import type { VirtuosoHandle } from "react-virtuoso";
import { chatUnreadCount, resetChatUnreadCount } from "./store";

interface NewMessagesPillProps {
  virtuosoRef: React.RefObject<VirtuosoHandle>;
}

export const NewMessagesPill = memo(function NewMessagesPill({
  virtuosoRef,
}: NewMessagesPillProps) {
  const theme = useTheme();
  const unreadCount = useAtomValue(chatUnreadCount);
  const resetUnread = useSetAtom(resetChatUnreadCount);

  const handleClick = useCallback(() => {
    virtuosoRef.current?.scrollToIndex({
      index: "LAST",
      align: "end",
    });
    resetUnread();
  }, [virtuosoRef, resetUnread]);

  if (unreadCount <= 0) return null;

  const displayCount = unreadCount > 99 ? "99+" : String(unreadCount);

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: "16px",
        right: "16px",
        zIndex: 2,
      }}
    >
      <Button
        variant="primary"
        size="small"
        onClick={handleClick}
        sx={{
          boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        New Message
        <Box
          component="span"
          sx={{
            ...theme.typography["body-small"],
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "18px",
            height: "18px",
            padding: "0 6px",
            borderRadius: "9999px",
            backgroundColor: theme.palette.error.main,
            color: "#FFF",
          }}
        >
          {displayCount}
        </Box>
      </Button>
    </Box>
  );
});
